import api from './api';

class UserService {
  async createUser(userData) {
    const response = await api.post('/api/users', userData);
    return response.data;
  }

  async getUsers(filters = {}) {
    const params = new URLSearchParams();
    if (filters.query) params.append('query', filters.query);
    if (filters.role) params.append('role', filters.role);
    if (filters.active !== undefined && filters.active !== '') params.append('active', filters.active);

    const response = await api.get(`/api/users?${params.toString()}`);
    return response.data;
  }

  async updateUser(userId, userData) {
    const response = await api.patch(`/api/users/${userId}`, userData);
    return response.data;
  }

  async changePassword(userId, newPassword) {
    const response = await api.patch(`/api/users/${userId}/password`, { new_password: newPassword });
    return response.data;
  }

  async deleteUser(userId) {
    const response = await api.delete(`/api/users/${userId}`);
    return response.data;
  }

  async getUserActivity(userId) {
    const response = await api.get(`/api/users/${userId}/activity`);
    return response.data;
  }
}

export default new UserService();
